(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-mystery-form]');
    const variants = JSON.parse(root.querySelector('[data-mystery-variants]').textContent);
    const strings = JSON.parse(root.querySelector('[data-mystery-strings]').textContent);
    const submit = root.querySelector('[data-mystery-submit]');
    const status = root.querySelector('[data-mystery-status]');
    const guide = root.querySelector('[data-mystery-guide]');
    const money = new Intl.NumberFormat('he-IL', { style: 'currency', currency: window.Shopify?.currency?.active || 'ILS' });
    let variant = null, busy = false;
    const checked = name => [...form.querySelectorAll(`input[name="${name}"]:checked`)].map(input => input.value);
    const normalize = value => value.toLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
    function conflict() {
      const excluded = form.elements.excluded.value.split(/[,;\n]/).map(normalize).filter(Boolean);
      return checked('preferences').some(value => excluded.includes(normalize(value)));
    }
    function refresh() {
      const options = [];
      root.querySelectorAll('[data-mystery-option]').forEach(fieldset => { options[Number(fieldset.dataset.mysteryOption)] = fieldset.querySelector('input:checked')?.value; });
      variant = variants.find(item => item.options.every((value, index) => value === options[index])) || null;
      const price = money.format((variant?.price ?? Math.min(...variants.map(item => item.price))) / 100);
      root.querySelector('[data-mystery-price]').textContent = price;
      root.querySelector('[data-mystery-total]').textContent = price;
      submit.textContent = !variant ? strings.choose : variant.available ? strings.add : strings.unavailable;
      submit.disabled = busy || !!(variant && !variant.available);
      root.querySelector('[data-mystery-summary]').textContent = [...options.filter(Boolean), checked('freedom')[0], form.elements.player.value.trim()].filter(Boolean).join(' · ');
      status.textContent = conflict() ? strings.contradiction : '';
    }
    form.addEventListener('input', refresh);
    form.addEventListener('change', event => {
      if (event.target.name === 'eras' && event.target.checked) {
        const exclusive = value => value.includes('MIX') || value.includes('לגמרי');
        form.querySelectorAll('input[name="eras"]').forEach(input => { if (input !== event.target && (exclusive(event.target.value) || exclusive(input.value))) input.checked = false; });
      }
      refresh();
    });
    if(window.PMConnectSizeGuide) window.PMConnectSizeGuide(root,variants,strings);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !variant || !variant.available || !form.reportValidity()) return;
      if (conflict()) { status.textContent = strings.contradiction; form.elements.excluded.focus(); return; }
      const properties = { [strings.printing]: 'כלול', _pm_mystery_selection: crypto.randomUUID() };
      const excluded = form.elements.excluded.value.trim(), player = form.elements.player.value.trim();
      if (excluded) properties[strings.excluded] = excluded;
      if (player) properties[strings.player] = player;
      const preferences = checked('preferences'), eras = checked('eras');
      if (preferences.length) properties[strings.preferences] = preferences.join(', ');
      if (eras.length) properties[strings.eras] = eras.join(', ');
      properties[strings.freedom] = checked('freedom')[0];
      busy = true; submit.disabled = true; submit.textContent = strings.busy; status.textContent = '';
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1,properties}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || strings.error);
        window.location.assign(root.dataset.cartUrl);
      } catch (error) { busy = false; refresh(); status.textContent = error.message || strings.error; }
    });
    refresh();
  }
  document.querySelectorAll('[data-pm-mystery]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pm-mystery]').forEach(init));
})();

